module.exports = __webpack_public_path__ + "img/labmem_text_btntest_sc.af3e99ed.png";